import { Injectable } from '@angular/core';
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Injectable({
    providedIn: 'root'
})
export class SeguimientoUserService {

    tvcModulo: any;
    url: string;
    urlSeguimiento: any = {};

    constructor(private utilService: UtilsService,
        private commom: CommonService) {
        this.url = this.utilService.getUrlIoIndustrias();
        this.urlSeguimiento = moduloPerform.url.seguimiento;
        
    }

    saveSeguimiento(innModulo: string) {
        this.commom.peticionPostConHeader(this.url + this.urlSeguimiento.base + innModulo, null)
            .subscribe(item => {
                console.log(item)
            }, error => {
                console.log(error)
            });
    }


    getAllSeguimiento(numeroSemana: string) {
        return this.commom.peticionGetConHeader(this.url + this.urlSeguimiento.reporte + '/' + numeroSemana);
    }

    //Feat: Ticket 30238 LOG de ingreso en modulos perform
    saveSeguimientoPerform(innModulo: string) {
        this.commom.peticionPostConHeader(this.url + this.urlSeguimiento.baseLogPerform + innModulo, null)
            .subscribe(item => {
                console.log(item)
            }, error => {
                console.log(error)
            });
    }

    getAllSeguimientoPerform(numeroSemana: string, usuario: string){
        let urlConsulta = this.url + this.urlSeguimiento.reportePerform + '/' + numeroSemana;
        if(usuario != ""){
            urlConsulta = this.url + this.urlSeguimiento.reportePerform + '/' + numeroSemana+"?usuario="+usuario;
        }
        return this.commom.peticionGetConHeader(urlConsulta);
    }
    //end T.30238
}